import { create } from "zustand";

interface StoreInterface {
  isOpen: boolean;
}

export default class GlobalSearchModalModel {
  static useState = create<StoreInterface>(() => ({ isOpen: false }));
  static setState = GlobalSearchModalModel.useState.setState;

  static open(): void {
    GlobalSearchModalModel.setState({ isOpen: true });
  }

  static close(): void {
    GlobalSearchModalModel.setState({ isOpen: false });
  }
}
